exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-header[data-v-2f7fdfc8]:hover {\n\tbackground-color: #e5e7eb;\n}\n", ""]);

// exports
